import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Table, Paragraph } from "@zillow/constellation";
import "react";
import MortgageRatesTableModal from "./MortgageRatesTableModal.esm.js";
const MortgageRatesTableContainer = ({
  children,
  ...props
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Table.Responsive, { children: /* @__PURE__ */ jsx(Table, { appearance: "horizontal", "aria-label": "Medium-sized zebra table", size: "md", children }) }),
  /* @__PURE__ */ jsxs(Paragraph, { fontType: "legal", padding: "sm", children: [
    "Last updated ",
    props == null ? void 0 : props.updatedAt,
    ".",
    " ",
    /* @__PURE__ */ jsx(MortgageRatesTableModal, { ...props })
  ] })
] });
export {
  MortgageRatesTableContainer as default
};
